'use client';

import { useEffect } from 'react';
import { useDiscountedPrice } from '@/hooks/useDiscountedPrice';
import { useIsClient } from '@/hooks/useIsClient';
import { getDiscountedPrice } from '@/utility/getDiscountedPrice';
import { tracker } from '@/utility/tracking/tracker';
import { Price, PriceProps } from './Price';

type DiscountedPriceProps = Pick<PriceProps, 'format'> & {
  price: number;
  productTypeId?: string;
  currentDiscountAmount?: number;
  isTrackedPrice?: boolean;
  excludePromoDiscount?: boolean;
};

export const DiscountedPrice = ({
  price,
  productTypeId,
  format = 'default',
  currentDiscountAmount = 0,
  isTrackedPrice = false,
  excludePromoDiscount = false,
}: DiscountedPriceProps) => {
  const priceWithVolumeDiscount = getDiscountedPrice(price, currentDiscountAmount);
  const discountedPrice = useDiscountedPrice(
    priceWithVolumeDiscount,
    excludePromoDiscount ? undefined : productTypeId
  );
  const isClient = useIsClient();
  const shouldShowDiscount = isClient && discountedPrice !== price;

  useEffect(() => {
    if (isTrackedPrice) {
      tracker.trackClientProduct({
        product: { discountedPrice: Math.round(discountedPrice * 100) / 100 },
      });
    }
  }, [isTrackedPrice, discountedPrice]);

  if (shouldShowDiscount) {
    return (
      <span>
        <Price format={format} className="mr-2 text-red-600">
          {discountedPrice}
        </Price>
        <Price className="line-through">{price}</Price>
      </span>
    );
  }

  return <Price format={format}>{price}</Price>;
};
